import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Heading, Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '../../hooks/useMediaQuery';
export function EmptyWalletList(props) {
    const { t } = useTranslation();
    /*
     * Illustration is 198x200 on mobile and 300x300 at >=640px. Styled inline
     * because the profile package has no CSS pipeline (no CSS modules), and
     * `justify-content: safe center` falls back to top-aligned when the content
     * overflows its scrollable container.
     */
    const isWideViewport = useMediaQuery('(min-width: 640px)');
    return (_jsxs(Flex, { direction: "column", align: "center", gap: "4", height: "100%", px: "4", py: "4", style: { justifyContent: 'safe center' }, children: [_jsx("img", { src: props.image, alt: t('No Wallet Found'), style: isWideViewport ? { width: 300, height: 300 } : { width: 198, height: 200 } }), _jsx(Heading, { size: "4", weight: "bold", children: t('No Wallet Found') }), _jsx(Text, { size: "2", align: "center", color: "gray", weight: "medium", mt: "4", children: t('There is no wallet found based on selected chain or search text, please try another chain or search query.') })] }));
}
